import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ChallanTable = ({ onPreview, onEdit, onDelete }) => {
  const [selectedChallans, setSelectedChallans] = useState([]);

  const challanData = [
    {
      id: "CH-2025-001",
      client: "AJIO",
      clientType: "online",
      invoiceId: "INV-2025-001",
      items: 125,
      totalPieces: 125,
      dispatchDate: "2025-01-22",
      expectedDelivery: "2025-01-25",
      status: "dispatched",
      trackingNumber: "TRK123456789",
      designs: ["Floral Print", "Abstract Design"],
      returnedPieces: 0
    },
    {
      id: "CH-2025-002",
      client: "Fashion Hub Pvt Ltd",
      clientType: "offline",
      invoiceId: "INV-2025-002",
      items: 200,
      totalPieces: 200,
      dispatchDate: "2025-01-20",
      expectedDelivery: "2025-01-23",
      status: "delivered",
      trackingNumber: "TRK123456790",
      designs: ["Geometric Pattern", "Vintage Style"],
      returnedPieces: 5
    },
    {
      id: "CH-2025-003",
      client: "MYNTRA",
      clientType: "online",
      invoiceId: "INV-2025-003",
      items: 300,
      totalPieces: 300,
      dispatchDate: "2025-01-18",
      expectedDelivery: "2025-01-21",
      status: "returned",
      trackingNumber: "TRK123456791",
      designs: ["Summer Collection", "Casual Wear"],
      returnedPieces: 25
    },
    {
      id: "CH-2025-004",
      client: "Style Store",
      clientType: "offline",
      invoiceId: "INV-2025-004",
      items: 150,
      totalPieces: 150,
      dispatchDate: "2025-01-15",
      expectedDelivery: "2025-01-18",
      status: "delivered",
      trackingNumber: "TRK123456792",
      designs: ["Ethnic Wear", "Traditional Print"],
      returnedPieces: 0
    },
    {
      id: "CH-2025-005",
      client: "Trendy Wear Co.",
      clientType: "offline",
      invoiceId: "INV-2025-005",
      items: 80,
      totalPieces: 80,
      dispatchDate: null,
      expectedDelivery: null,
      status: "pending",
      trackingNumber: null,
      designs: ["Modern Print", "Youth Collection"],
      returnedPieces: 0
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'delivered': return 'text-success bg-success/10';
      case 'dispatched': return 'text-primary bg-primary/10';
      case 'returned': return 'text-warning bg-warning/10';
      case 'pending': return 'text-muted-foreground bg-muted/50';
      case 'cancelled': return 'text-error bg-error/10';
      default: return 'text-muted-foreground bg-muted/50';
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedChallans(challanData.map(challan => challan.id));
    } else {
      setSelectedChallans([]);
    }
  };

  const handleSelectChallan = (challanId, checked) => {
    if (checked) {
      setSelectedChallans([...selectedChallans, challanId]);
    } else {
      setSelectedChallans(selectedChallans.filter(id => id !== challanId));
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      {/* Table Header Actions */}
      <div className="p-4 border-b border-border bg-muted/30">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <h3 className="text-lg font-semibold text-foreground">Delivery Challans</h3>
            <span className="text-sm text-muted-foreground">
              {challanData.length} total challans
            </span>
          </div>
          {selectedChallans.length > 0 && (
            <div className="flex items-center space-x-2">
              <span className="text-sm text-muted-foreground">
                {selectedChallans.length} selected
              </span>
              <Button variant="outline" size="sm" iconName="Truck" iconPosition="left">
                Update Status
              </Button>
              <Button variant="outline" size="sm" iconName="Download" iconPosition="left">
                Export
              </Button>
            </div>
          )}
        </div>
      </div>

      {/* Desktop Table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="text-left p-4 font-medium text-foreground">
                <input
                  type="checkbox"
                  checked={selectedChallans.length === challanData.length}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                  className="rounded border-border"
                />
              </th>
              <th className="text-left p-4 font-medium text-foreground">Challan ID</th>
              <th className="text-left p-4 font-medium text-foreground">Client</th>
              <th className="text-left p-4 font-medium text-foreground">Invoice ID</th>
              <th className="text-left p-4 font-medium text-foreground">Items</th>
              <th className="text-left p-4 font-medium text-foreground">Dispatch Date</th>
              <th className="text-left p-4 font-medium text-foreground">Expected Delivery</th>
              <th className="text-left p-4 font-medium text-foreground">Status</th>
              <th className="text-left p-4 font-medium text-foreground">Tracking</th>
              <th className="text-left p-4 font-medium text-foreground">Actions</th>
            </tr>
          </thead>
          <tbody>
            {challanData.map((challan) => (
              <tr key={challan.id} className="border-b border-border hover:bg-muted/30 transition-smooth">
                <td className="p-4">
                  <input
                    type="checkbox"
                    checked={selectedChallans.includes(challan.id)}
                    onChange={(e) => handleSelectChallan(challan.id, e.target.checked)}
                    className="rounded border-border"
                  />
                </td>
                <td className="p-4">
                  <div className="font-medium text-foreground">{challan.id}</div>
                  {challan.returnedPieces > 0 && (
                    <div className="text-xs text-warning mt-1">
                      {challan.returnedPieces} returned
                    </div>
                  )}
                </td>
                <td className="p-4">
                  <div className="font-medium text-foreground">{challan.client}</div>
                  <div className="flex items-center space-x-1 mt-1">
                    <Icon 
                      name={challan.clientType === 'online' ? 'Globe' : 'Store'} 
                      size={12} 
                      className="text-muted-foreground" 
                    />
                    <span className="text-xs text-muted-foreground capitalize">
                      {challan.clientType}
                    </span>
                  </div>
                </td>
                <td className="p-4">
                  <div className="text-primary font-medium">{challan.invoiceId}</div>
                </td>
                <td className="p-4">
                  <div className="font-medium text-foreground">{challan.totalPieces}</div>
                  <div className="text-sm text-muted-foreground">{challan.items} designs</div>
                </td>
                <td className="p-4">
                  <div className="text-foreground">{formatDate(challan.dispatchDate)}</div>
                </td>
                <td className="p-4">
                  <div className="text-foreground">{formatDate(challan.expectedDelivery)}</div>
                </td>
                <td className="p-4">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(challan.status)}`}>
                    {challan.status.charAt(0).toUpperCase() + challan.status.slice(1)}
                  </span>
                </td>
                <td className="p-4">
                  {challan.trackingNumber ? (
                    <div className="text-sm">
                      <div className="font-mono text-foreground">{challan.trackingNumber}</div>
                      <button className="text-xs text-primary hover:underline mt-1">
                        Track Package
                      </button>
                    </div>
                  ) : (
                    <span className="text-muted-foreground text-sm">-</span>
                  )}
                </td>
                <td className="p-4">
                  <div className="flex items-center space-x-1">
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onPreview(challan)}
                      iconName="Eye"
                      iconSize={16}
                    />
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onEdit(challan)}
                      iconName="Edit"
                      iconSize={16}
                    />
                    {challan.status === 'delivered' && (
                      <Button
                        variant="ghost"
                        size="icon"
                        iconName="RotateCcw"
                        iconSize={16}
                        className="text-warning hover:text-warning"
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="lg:hidden space-y-4 p-4">
        {challanData.map((challan) => (
          <div key={challan.id} className="border border-border rounded-lg p-4 space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={selectedChallans.includes(challan.id)}
                  onChange={(e) => handleSelectChallan(challan.id, e.target.checked)}
                  className="rounded border-border"
                />
                <div className="font-medium text-foreground">{challan.id}</div>
              </div>
              <div className="flex items-center space-x-1">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onPreview(challan)}
                  iconName="Eye"
                  iconSize={16}
                />
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onEdit(challan)}
                  iconName="Edit"
                  iconSize={16}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 text-sm">
              <div>
                <span className="text-muted-foreground">Client:</span>
                <div className="font-medium text-foreground">{challan.client}</div>
              </div>
              <div>
                <span className="text-muted-foreground">Invoice:</span>
                <div className="text-primary font-medium">{challan.invoiceId}</div>
              </div>
              <div>
                <span className="text-muted-foreground">Items:</span>
                <div className="font-medium text-foreground">{challan.totalPieces} pieces</div>
              </div>
              <div>
                <span className="text-muted-foreground">Dispatch:</span>
                <div className="text-foreground">{formatDate(challan.dispatchDate)}</div>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(challan.status)}`}>
                {challan.status.charAt(0).toUpperCase() + challan.status.slice(1)}
              </span>
              {challan.trackingNumber && (
                <div className="text-xs">
                  <span className="text-muted-foreground">Tracking: </span>
                  <span className="font-mono text-foreground">{challan.trackingNumber}</span>
                </div>
              )}
            </div>

            {challan.returnedPieces > 0 && (
              <div className="bg-warning/10 border border-warning/20 rounded-md p-2">
                <div className="text-xs text-warning font-medium">
                  {challan.returnedPieces} pieces returned
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChallanTable;